// extracted by mini-css-extract-plugin
export default {"body":"khabibullo_body__hJ0kZ","container":"khabibullo_container__y4EBI","img":"khabibullo_img__PEM+z","imgme":"khabibullo_imgme__t6nyB","h3":"khabibullo_h3__joTc+"};